import { render, staticRenderFns } from "./CCSidebarView.vue?vue&type=template&id=180734cb&scoped=true&"
import script from "./CCSidebarView.vue?vue&type=script&lang=ts&"
export * from "./CCSidebarView.vue?vue&type=script&lang=ts&"
import style0 from "./CCSidebarView.vue?vue&type=style&index=0&id=180734cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180734cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VList,VRow})
